module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_8019.d1318cad.png";